import { useEffect, useState } from 'react';

export type PortalTarget = 'dropdown' | 'modal' | 'toast';

export function usePortal(target: PortalTarget = 'dropdown'): HTMLElement | null {
  const [root, setRoot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const rootId = `${target}-root`;
    let element = document.getElementById(rootId);

    if (!element) {
      element = document.createElement('div');
      element.id = rootId;
      document.body.appendChild(element);
    }

    setRoot(element);
  }, [target]);

  return root;
}
